import { ListFieldSection } from 'Components/Layout';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { Checkbox, Field, NumericInput, TextOutput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { IWithWorksheetInjectedProps, WorksheetGridFieldSection, WorksheetRecordGrid } from '../../../../Core';

let AsLiquidLimitOnePointTrialSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t, i) => ({
        dim: t.ExcludedTrial,
        preventRemove: i < 4,
        SuitableForShrinkage: t.SuitableForShrinkage,
      }))
    ),
    deepEquals
  );

  return (
    <>
      <WorksheetGridFieldSection name="Trials">
        <WorksheetRecordGrid
          name={'Trials'}
          orientation={'horizontal'}
          recordProps={{
            width: 130,
            dim: (i) => trialRecordProps[i]?.dim,
            enforceAtLeastOneRecord: true,
            removeConfirm: {
              confirm: true,
              confirmTitle: 'Trial Deletion',
              confirmText: 'Are you sure you want to delete the selected trial?',
              confirmButtonText: 'Delete Trial',
            },
          }}
          fieldSet={[
            {
              name: 'NumberOfDrops',
              component: <Field input={<NumericInput />} />,
              label: 'blows',
            },
            {
              name: 'ExcludedTrial',
              component: <Field input={<Checkbox />} />,
              label: 'Exclude Trial',
            },
          ]}
        />
      </WorksheetGridFieldSection>
      <ListFieldSection>
        <Field input={<TextOutput />} name="NumberOfBlows" />
      </ListFieldSection>
    </>
  );
};

AsLiquidLimitOnePointTrialSection = withInjectedProps(AsLiquidLimitOnePointTrialSection);

export { AsLiquidLimitOnePointTrialSection };
export default AsLiquidLimitOnePointTrialSection;
